/* eslint-disable @typescript-eslint/unbound-method */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { UserDO } from 'wdna-components';
import UiValidate from 'wdna-components/lib/forms/validation/UiValidate';
import { messageError, messageInfo } from 'wdna-components/lib/helpers/notification';
import { getErrorMessage } from 'wdna-components/lib/helpers/response';

import Auth from '../../../services/auth/Auth';

import { authorization } from '../../../services/user/requests';
import { getLoggedUserInfo } from '../../../services/user/actions';

interface State {
  name?: string;
  email?: string;

  passwordOld?: string;
  passwordNew?: string;
  passwordChk?: string;

  loading?: boolean;
}

export default class UserPassword extends React.Component<unknown, State> {
  public constructor(props: unknown) {
    super(props);

    this.state = {
      // Login del usuario
      name: '',
      email: '',

      passwordOld: '',
      passwordNew: '',
      passwordChk: '',

      loading: false,
    };
  }

  public componentDidMount = (): void => {
    this.getData();
  }

  public getData = (): void => {
    getLoggedUserInfo()
      .then((user: UserDO) => {
        this.setState({
          name: user.name,
          email: user.email,
        });
      })
      .catch((error: any) => {
        messageError('Error', getErrorMessage(error));
      });
  }

  public chkPassword = (password: string): boolean => {
    const regex: RegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
    if (password.match(regex)) {
      return true;
    }
    messageError('Error', 'Password must be between 6 to 20 characters which contain at least one numeric digit, one uppercase and one lowercase letter');
    return false;
  }

  public handleFormSubmit(e: React.FormEvent<HTMLFormElement>): void {
    e.preventDefault();
    this.loadingStart();

    const { passwordOld, passwordNew, passwordChk } = this.state;
    if (passwordOld && passwordNew && passwordNew === passwordChk && this.chkPassword(passwordNew)) {
      const options: any = { headers: { token: Auth.getToken() } };
      const formData: FormData = new FormData();
      formData.append('pold', passwordOld);
      formData.append('pnew', passwordNew);
      authorization('password', formData, options)
        ?.then(() => {
          messageInfo('Success', 'Data saved successfully', 5000);
        })
        .catch((error: any) => {
          messageError('Error', getErrorMessage(error));
        })
        .finally(() => {
          this.loadingFinish();
        });
    } else {
      messageError('Error', 'Password Confirm incorrect!!');
    }
  }

  public handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
    const { name, value } = e.target;

    this.setState((prevState: State) => ({
      ...prevState,
      [name]: value,
    }));
  }

  public loadingStart = (): void => {
    this.setState({ loading: true });
  }

  public loadingFinish = (): void => {
    this.setState({ loading: false });
  }

  public render(): JSX.Element {
    return (
      <UiValidate>
        <form className="smart-form" onSubmit={this.handleFormSubmit}>
          <fieldset>
            <label className="label">User account</label>
            <section>
              <label className="input">
                <i className="icon-append fa fa-user" />
                <input
                  type="text"
                  value={this.state.name}
                  onChange={this.handleChange}
                  name="name"
                  placeholder="User name"
                  disabled
                />
              </label>
            </section>

            <section>
              <label className="input">
                <i className="icon-append fa fa-envelope" />
                <input
                  type="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  name="email"
                  placeholder="Email"
                  disabled
                />
              </label>
            </section>

            <section>
              <label className="input">
                <i className="icon-append fa fa-lock" />
                <input
                  type="password"
                  value={this.state.passwordOld}
                  onChange={this.handleChange}
                  name="passwordOld"
                  placeholder="Old Password"
                  id="passwordOld"
                />
                <b className="tooltip tooltip-bottom-right">Old password</b>
              </label>
            </section>

            <section>
              <label className="input">
                <i className="icon-append fa fa-lock" />
                <input
                  type="password"
                  value={this.state.passwordNew}
                  onChange={this.handleChange}
                  name="passwordNew"
                  placeholder="New Password"
                  id="passwordNew"
                />
                <b className="tooltip tooltip-bottom-right">New password</b>
              </label>
            </section>

            <section>
              <label className="input">
                <i className="icon-append fa fa-lock" />
                <input
                  type="password"
                  value={this.state.passwordChk}
                  onChange={this.handleChange}
                  name="passwordChk"
                  placeholder="Confirm password"
                />
                <b className="tooltip tooltip-bottom-right">Confirm password</b>
              </label>
            </section>
          </fieldset>

          <footer>
            <div className="text-right">
              {this.state.loading && <img className="loading-wdna" src="assets/img/loading-wdna.gif" alt="logo" />}

              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </footer>
        </form>
      </UiValidate>
    );
  }
}
